/**
 * Phones only: while the product form with a sticky Add to Cart bar
 * (.add-to-cart-wrapper--sticky) reaches into the bottom half of the screen, <html> carries
 * .sticky-atc-active, and embark-custom.css fades out the Zendesk chat launcher that would sit
 * on top of the bar. Once the form's end rises above the middle of the screen (or before it
 * gets there) the corner is clear, and the launcher fades back in — no measuring the widget.
 * Re-binds after a combined-listing swap replaces the form. See context/builder.md.
 */
(() => {
  if (!('IntersectionObserver' in window)) return;

  const mobile = window.matchMedia('(max-width: 768.98px)');
  let formInView = false;

  const reflect = () => {
    document.documentElement.classList.toggle('sticky-atc-active', mobile.matches && formInView);
  };

  // The root shrinks to the bottom half of the viewport — where the launcher lives.
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      formInView = entry.isIntersecting;
    });
    reflect();
  }, { rootMargin: '-50% 0px 0px 0px' });

  function bind() {
    observer.disconnect();
    formInView = false;
    reflect();
    const form = document.querySelector('.add-to-cart-wrapper--sticky')?.closest('form');
    if (form) observer.observe(form);
  }

  bind();
  mobile.addEventListener('change', reflect);
  document.addEventListener('on:product:change', bind);
})();
